/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/
/**
 * author: tman
 */

import React from 'react';
import PropTypes from 'prop-types';

const Info = (props) => {
    const { content,} = props;

    return (
        <p className="ao-form-info font-body1" data-key={content.dataKey}>
            {content.text}
        </p>
    )
};

Info.propTypes = {
    content: PropTypes.object.isRequired,
};

Info.defaultProps = {
    content: {},
};

export default Info;



// WEBPACK FOOTER //
// ./src/views/AOFormReview/components/Info/index.js